/* Esencia de Úbeda — comportamiento del tema. Sin dependencias externas. */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------------
     Menú móvil
     ------------------------------------------------------------------ */
  var botonMenu = $('[data-abrir-menu]');
  var panelMenu = $('[data-menu-movil]');
  if (botonMenu && panelMenu) {
    botonMenu.addEventListener('click', function () {
      var abierto = botonMenu.getAttribute('aria-expanded') === 'true';
      botonMenu.setAttribute('aria-expanded', String(!abierto));
      panelMenu.hidden = abierto;
    });
  }

  /* ------------------------------------------------------------------
     Pasos de cantidad (- n +)
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-paso]');
    if (!b) return;
    var caja = b.closest('.pasos');
    var input = caja && caja.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var v = parseInt(input.value || '0', 10) + parseInt(b.dataset.paso, 10);
    input.value = String(Math.max(min, v));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------
     Galería de producto
     ------------------------------------------------------------------ */
  var principal = $('[data-imagen-principal]');
  if (principal) {
    $$('[data-miniatura]').forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-src');
        if (!src) return;
        principal.setAttribute('src', src);
        principal.setAttribute('alt', b.getAttribute('data-alt') || '');
        principal.removeAttribute('srcset');
        $$('[data-miniatura]').forEach(function (o) {
          o.setAttribute('aria-current', o === b ? 'true' : 'false');
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Cajón de cesta
     ------------------------------------------------------------------ */
  var cajon = $('[data-cajon]');
  var velo  = $('[data-velo]');
  var ultimoFoco = null;

  function abrirCajon() {
    if (!cajon) return;
    ultimoFoco = document.activeElement;
    cajon.setAttribute('data-abierto', '');
    if (velo) velo.setAttribute('data-abierto', '');
    cajon.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var cerrar = cajon.querySelector('.cerrar');
    if (cerrar) cerrar.focus();
  }

  function cerrarCajon() {
    if (!cajon) return;
    cajon.removeAttribute('data-abierto');
    if (velo) velo.removeAttribute('data-abierto');
    cajon.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-abrir-cajon]')) { e.preventDefault(); abrirCajon(); }
    if (e.target.closest('[data-cerrar-cajon]')) { e.preventDefault(); cerrarCajon(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !cajon || !cajon.hasAttribute('data-abierto')) return;
    cerrarCajon();
  });

  /* foco encerrado dentro del cajón mientras está abierto */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !cajon || !cajon.hasAttribute('data-abierto')) return;
    var focos = $$('a[href],button:not([disabled]),input,select,textarea', cajon)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focos.length) return;
    var primero = focos[0], ultimo = focos[focos.length - 1];
    if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
  });

  /* --- refrescar el cajón con la API de secciones --- */
  function refrescarCajon() {
    return fetch(window.Shopify.routes.root + '?sections=cajon-cesta')
      .then(function (r) { return r.json(); })
      .then(function (datos) {
        var html = datos['cajon-cesta'];
        if (!html || !cajon) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var nuevo = temp.querySelector('[data-cajon-interior]');
        var actual = cajon.querySelector('[data-cajon-interior]');
        if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
        actualizarContador();
      });
  }

  function actualizarContador() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cesta) {
        $$('[data-contador-cesta]').forEach(function (el) {
          el.textContent = cesta.item_count;
          el.classList.toggle('vacia', cesta.item_count === 0);
        });
      })
      .catch(function () { /* silencioso: el contador no es crítico */ });
  }

  /* --- añadir al carrito sin recargar, con error en línea --- */
  var formProducto = $('[data-form-producto]');
  if (formProducto) {
    formProducto.addEventListener('submit', function (e) {
      e.preventDefault();

      var botones = $$('[data-anadir]');
      var error = $('[data-error-compra]');
      if (error) { error.hidden = true; error.textContent = ''; }
      botones.forEach(function (b) { b.disabled = true; });

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(formProducto)
      })
        .then(function (r) {
          return r.json().then(function (datos) {
            if (!r.ok) throw new Error(datos.description || datos.message || 'No se pudo añadir a la cesta.');
            return datos;
          });
        })
        .then(function () { return refrescarCajon(); })
        .then(function () { abrirCajon(); })
        .catch(function (err) {
          if (error) {
            error.textContent = err.message || 'No se pudo añadir a la cesta. Inténtalo de nuevo.';
            error.hidden = false;
          }
        })
        .then(function () {
          botones.forEach(function (b) { b.disabled = false; });
        });
    });
  }

  /* --- cambiar cantidad o quitar líneas dentro del cajón --- */
  document.addEventListener('click', function (e) {
    var quitar = e.target.closest('[data-quitar]');
    if (!quitar) return;
    e.preventDefault();
    cambiarLinea(quitar.dataset.quitar, 0);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cantidad-linea]');
    if (!input) return;
    cambiarLinea(input.dataset.cantidadLinea, parseInt(input.value, 10));
  });

  function cambiarLinea(clave, cantidad) {
    if (!clave) return;
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: clave, quantity: cantidad })
    })
      .then(function () { return refrescarCajon(); })
      .catch(function () { window.location.href = window.Shopify.routes.root + 'cart'; });
  }

  /* ------------------------------------------------------------------
     Selector de idioma y moneda: enviar al cambiar
     ------------------------------------------------------------------ */
  $$('[data-form-localizacion] select').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var f = sel.closest('form');
      if (f) f.submit();
    });
  });

  /* ------------------------------------------------------------------
     Selector de variantes por opciones
     Empareja las opciones marcadas con la variante correspondiente.
     Funciona con una, dos o tres opciones.
     ------------------------------------------------------------------ */
  (function variantes() {
    var deposito = $('[data-variantes]');
    if (!deposito) return;

    var lista;
    try { lista = JSON.parse(deposito.textContent); } catch (e) { return; }
    if (!Array.isArray(lista) || !lista.length) return;

    var campoId = $('[data-id-variante]');
    var radios = $$('[data-opcion]');
    if (!radios.length) return;

    function seleccionadas() {
      var valores = [];
      $$('.opciones').forEach(function (grupo) {
        var idx = parseInt(grupo.dataset.opcionIndice, 10);
        var marcado = grupo.querySelector('input:checked');
        valores[idx] = marcado ? marcado.value : null;
      });
      return valores;
    }

    function buscar(valores) {
      for (var i = 0; i < lista.length; i++) {
        var coincide = true;
        for (var j = 0; j < valores.length; j++) {
          if (valores[j] !== null && lista[i].options[j] !== valores[j]) { coincide = false; break; }
        }
        if (coincide) return lista[i];
      }
      return null;
    }

    /* tacha las combinaciones que no existen o están agotadas */
    function marcarDisponibilidad() {
      var valores = seleccionadas();
      $$('.opciones').forEach(function (grupo) {
        var idx = parseInt(grupo.dataset.opcionIndice, 10);
        $$('input[data-opcion]', grupo).forEach(function (radio) {
          var prueba = valores.slice();
          prueba[idx] = radio.value;
          var encontrada = buscar(prueba);
          radio.disabled = !encontrada || !encontrada.available;
        });
      });
    }

    function dinero(centimos) {
      /* usa el formato de la tienda si está disponible; si no, formato español */
      if (window.Shopify && window.Shopify.formatMoney && window.themeMoneyFormat) {
        try { return window.Shopify.formatMoney(centimos, window.themeMoneyFormat); } catch (e) { /* sigue abajo */ }
      }
      return (centimos / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function aplicar(variante) {
      if (!variante) return;

      if (campoId) campoId.value = variante.id;

      $$('[data-precio]').forEach(function (el) { el.textContent = dinero(variante.price); });

      $$('[data-precio-antes]').forEach(function (el) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          el.textContent = dinero(variante.compare_at_price);
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });

      $$('[data-unidad]').forEach(function (el) {
        if (variante.unit_price && variante.unit_price_measurement) {
          var m = variante.unit_price_measurement;
          el.textContent = dinero(variante.unit_price) + ' / ' + m.reference_value + m.reference_unit;
        } else {
          el.textContent = '';
        }
      });

      var pocas = parseInt(document.body.dataset.umbralPocas || '10', 10);
      $$('[data-stock]').forEach(function (el) {
        var q = variante.inventory_quantity;
        var mostrar = variante.available &&
                      variante.inventory_management &&
                      typeof q === 'number' && q > 0 && q <= pocas;
        el.hidden = !mostrar;
        var num = el.querySelector('[data-stock-num]');
        if (num && mostrar) num.textContent = q;
      });

      $$('[data-anadir]').forEach(function (b) {
        b.disabled = !variante.available;
        b.textContent = variante.available ? b.dataset.textoAnadir : b.dataset.textoAgotado;
      });

      /* imagen de la variante, si tiene una propia */
      if (variante.featured_media && variante.featured_media.id) {
        var mini = $('[data-miniatura][data-media-id="' + variante.featured_media.id + '"]');
        if (mini) mini.click();
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variante.id);
        window.history.replaceState({}, '', url);
      } catch (e) { /* no crítico */ }
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        marcarDisponibilidad();
        aplicar(buscar(seleccionadas()));
      });
    });

    marcarDisponibilidad();
  })();

  /* ------------------------------------------------------------------
     Búsqueda predictiva
     ------------------------------------------------------------------ */
  (function buscador() {
    var capa = $('[data-capa-buscar]');
    if (!capa) return;

    var input = capa.querySelector('input[type="search"]');
    var salida = capa.querySelector('[data-resultados]');
    var estado = capa.querySelector('[data-estado-buscar]');
    var temporizador = null;
    var focoPrevio = null;

    function abrir() {
      focoPrevio = document.activeElement;
      capa.setAttribute('data-abierto', '');
      document.body.style.overflow = 'hidden';
      if (input) { input.value = ''; input.focus(); }
      if (salida) salida.innerHTML = '';
      if (estado) estado.textContent = 'Escribe para buscar';
    }

    function cerrar() {
      capa.removeAttribute('data-abierto');
      document.body.style.overflow = '';
      if (focoPrevio && focoPrevio.focus) focoPrevio.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-abrir-buscar]')) { e.preventDefault(); abrir(); }
      if (e.target.closest('[data-cerrar-buscar]')) { e.preventDefault(); cerrar(); }
      if (e.target === capa) cerrar();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && capa.hasAttribute('data-abierto')) cerrar();
      /* atajo: barra "/" abre el buscador si no estás escribiendo */
      if (e.key === '/' && !/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) {
        e.preventDefault();
        abrir();
      }
    });

    if (!input) return;

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(temporizador);

      if (q.length < 2) {
        if (salida) salida.innerHTML = '';
        if (estado) estado.textContent = 'Escribe para buscar';
        return;
      }

      if (estado) estado.textContent = 'Buscando…';

      temporizador = setTimeout(function () {
        var url = window.Shopify.routes.root + 'search/suggest.json' +
                  '?q=' + encodeURIComponent(q) +
                  '&resources[type]=product,article,page' +
                  '&resources[limit]=6';

        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (datos) {
            var rec = (datos.resources && datos.resources.results) || {};
            var productos = rec.products || [];
            var otros = (rec.pages || []).concat(rec.articles || []);

            if (!productos.length && !otros.length) {
              if (salida) salida.innerHTML = '';
              if (estado) estado.textContent = 'Sin resultados para «' + q + '»';
              return;
            }

            if (estado) estado.textContent = (productos.length + otros.length) + ' resultados';

            var html = productos.map(function (p) {
              var img = p.featured_image && p.featured_image.url
                ? '<div class="marco-imagen"><img src="' + p.featured_image.url + '" alt="" width="56" height="56" loading="lazy"></div>'
                : '<div class="marco-imagen"></div>';
              return '<li><a href="' + p.url + '">' + img +
                     '<strong>' + p.title + '</strong>' +
                     '<span class="pr">' + (p.price ? p.price : '') + '</span></a></li>';
            }).join('');

            html += otros.map(function (o) {
              return '<li><a href="' + o.url + '"><div class="marco-imagen"></div>' +
                     '<strong>' + o.title + '</strong><span class="pr"></span></a></li>';
            }).join('');

            if (salida) salida.innerHTML = html;
          })
          .catch(function () {
            if (estado) estado.textContent = 'No se pudo buscar. Prueba otra vez.';
          });
      }, 220);
    });
  })();


  /* ------------------------------------------------------------------
     Vídeos del tema (portada y cualquier hueco de imagen)
     Pausa manual, respeto al ahorro de movimiento, parada al salir de
     pantalla y con la pestaña en segundo plano.
     ------------------------------------------------------------------ */
  (function videos() {
    var menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)');

    function preparar(video) {
      if (!video || video.dataset.preparado) return;
      video.dataset.preparado = '1';

      var caja = video.closest('.portada-marco, .marco-imagen') || video.parentElement;
      var boton = caja ? caja.querySelector('[data-portada-pausa], [data-media-pausa]') : null;
      var pausadoPorMi = false;

      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');

      function sincronizar(reproduciendo) {
        if (!boton) return;
        boton.setAttribute('aria-pressed', String(!reproduciendo));
        boton.setAttribute('aria-label', reproduciendo ? 'Pausar el vídeo' : 'Reproducir el vídeo');
        var iPausa = boton.querySelector('[data-icono-pausa]');
        var iPlay = boton.querySelector('[data-icono-play]');
        if (iPausa) iPausa.hidden = !reproduciendo;
        if (iPlay) iPlay.hidden = reproduciendo;
      }

      function reproducir() {
        var p = video.play();
        if (p && p.catch) p.catch(function () { /* bloqueado por el navegador: queda el póster */ });
      }

      if (menosMovimiento.matches) { video.pause(); sincronizar(false); }
      else { reproducir(); sincronizar(true); }

      if (boton) {
        boton.addEventListener('click', function () {
          if (video.paused) { reproducir(); pausadoPorMi = false; sincronizar(true); }
          else { video.pause(); pausadoPorMi = true; sincronizar(false); }
        });
      }

      if ('IntersectionObserver' in window && caja) {
        new IntersectionObserver(function (entradas) {
          entradas.forEach(function (e) {
            if (pausadoPorMi || menosMovimiento.matches) return;
            if (e.isIntersecting) reproducir(); else video.pause();
          });
        }, { threshold: 0.15 }).observe(caja);
      }

      document.addEventListener('visibilitychange', function () {
        if (pausadoPorMi || menosMovimiento.matches) return;
        if (document.hidden) video.pause(); else reproducir();
      });
    }

    $$('[data-portada] video, [data-media-video], .marco-imagen video').forEach(preparar);
  })();

  /* ------------------------------------------------------------------
     Productos recomendados
     El objeto `recommendations` de Liquid viene vacío en una carga normal:
     Shopify solo lo rellena si se pide la sección por su propia ruta.
     ------------------------------------------------------------------ */
  (function recomendados() {
    var caja = $('[data-recomendados]');
    if (!caja || !caja.dataset.url) return;

    fetch(caja.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var nuevo = temp.querySelector('[data-recomendados]');
        if (nuevo && nuevo.innerHTML.trim()) caja.innerHTML = nuevo.innerHTML;
      })
      .catch(function () { /* sin recomendaciones: la sección se queda vacía */ });
  })();


  /* ------------------------------------------------------------------
     Tramitar pedido
     OJO: no se puede desactivar el botón dentro del submit. Si se
     desactiva, el navegador deja de enviar su par name=value y Shopify
     nunca recibe "checkout", así que el formulario recarga /cart y
     aparenta no hacer nada. Se bloquea con una bandera, no con disabled.
     ------------------------------------------------------------------ */
  (function tramitar() {
    var enviando = false;

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.querySelector || !form.querySelector('[data-tramitar]')) return;

      if (enviando) { e.preventDefault(); return; }
      enviando = true;

      var boton = form.querySelector('[data-tramitar]');
      if (boton) {
        boton.setAttribute('aria-busy', 'true');
        boton.classList.add('cargando');
        boton.textContent = 'Llevándote al pago…';
      }

      /* si el navegador vuelve atrás desde el pago, se reactiva */
      setTimeout(function () {
        enviando = false;
        if (boton) {
          boton.removeAttribute('aria-busy');
          boton.classList.remove('cargando');
          boton.textContent = 'Tramitar pedido';
        }
      }, 8000);
    });
  })();

})();
